import { render, staticRenderFns } from "./app-primary.vue?vue&type=template&id=ec0893dc&scoped=true&"
import script from "./app-primary.vue?vue&type=script&lang=js&"
export * from "./app-primary.vue?vue&type=script&lang=js&"
import style0 from "./app-primary.vue?vue&type=style&index=0&id=ec0893dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0893dc",
  null
  
)

export default component.exports